import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from 'react-router-dom';
import * as Yup from "yup";
import StickButtonsBloc from '../../blocs/common/StickButtonsBloc';
import { APP_URLS } from '../../const/AppConst';
import useAppState from '../../context/AppContext';
import MgpMessage from "../../elements/MgpMessage/MgpMessage";
import LoaderModal from "../../modals/common/LoaderModal";
import { isPropositionInLock, } from "../../utils/dataUtils";
import { useFetchNomenclature } from "../../hooks/useFetchNomenclature";

const options = [
    {
        id: '1',
        type: 'Option Supplémentaire',
        name: "Lunettes",
        amount: 10,
        avantages: [
            'Lunettes (monture et verres) : jusqu\'à 250 €'
        ],
        icon: "lunettes"
    },
    {
        id: '2',
        type: 'Option Supplémentaire',
        name: "Dentaire",
        amount: 10,
        avantages: [
            'Dentaire : 350 € / couronne'
        ],
        icon: 'dent'
    },
    {
        id: '3',
        type: 'Option Supplémentaire',
        name: "Hopitalisation",
        amount: 10,
        avantages: [
            'Hospitalisation chambre particulière : 80 € / jour',
            'Accompagnant : 60 € / jour'
        ],
        icon: 'trousse-secours'
    }
]

type InfoOptionsFormData = {
  
  }

export default function InfoOptionsFormComponent() {
  const [errorMsg, setErrorMsg] = useState<string | null>();

  const navigate = useNavigate();

  const {
    state: { proposition, showModal, additionals },
    dispatch,
  } = useAppState();

  useFetchNomenclature("civility");

   
  
  const validationSchema = Yup.object().shape({})
  const {
    handleSubmit,
    formState: { isSubmitting },
  } = useForm<InfoOptionsFormData>({
    defaultValues: {
     
    },
    mode: "onBlur",
    reValidateMode: "onChange",
    resolver: yupResolver(validationSchema),
  });

  const onNextAction = () => {
    setErrorMsg(null);

    dispatch({type: 'NEXT_INFO_STEP', path: APP_URLS.infoBeneficiaryStep2Page});
    navigate({
      pathname: APP_URLS.infoBeneficiaryStep2Page,
      search: `?id=${proposition!.propositionId}`,
    }); 
   
  }
  
  const onPreviousAction = () => {
    dispatch({type: 'BACK_INFO_STEP', path: APP_URLS.infoBeneficiaryStep1Page});
    navigate({
      pathname: APP_URLS.infoBeneficiaryStep1Page,
      search: `?id=${proposition!.propositionId}`,
    }); 
  }




  const onSelectAction = (e: any, option: any) => {
    e.preventDefault();
    const index = additionals.findIndex(el => el.id === option.id);
    if (index === -1) {
        dispatch({type: 'ADD_ADDITIONAL_OPTION', additionals: [...additionals, {name: option.name, type: option.type, amount: option.amount, id: option.id}]});
    } 
  }

  const onUnselectAction = (e: any, option: any) => {
    e.preventDefault();
    const index = additionals.findIndex(el => el.id === option.id);
    if (index !== -1) {
        let additionalArr = [...additionals]
        additionalArr.splice(index, 1)
        dispatch({type: 'ADD_ADDITIONAL_OPTION', additionals: additionalArr});
    } 
  }

  const isSelected = (optionName: string) => {
    if (additionals.find(el => el.name === optionName)) return true;
    else return false;
  }

  return (
    <form style={{width: '100%'}}>
      <div>
        {errorMsg && <MgpMessage type="danger" message={errorMsg} hasCloseBtn={false}/>}
      </div>
        
      <div className='grid-flex jc-start m-y-md'>
        {
            options.map(option => (
                <div key={option.id} className={`card-contrats hover box ${isSelected(option.name) && 'box-selected'}`}>
                    <div className='card' style={{gap: 0, flexWrap: "nowrap", display: 'flex', flexDirection: 'column'}}>
                        <div className="grid-flex jc-space-arround jc-start" >
                            <p className="card-title bleu flex va-center" style={{gap: 0}}><i className={`icon-${option.icon} bleu fz-lg`}></i>{option.name}</p>
                            {isSelected(option.name) && <i className="icon-coche fz-lg" style={{marginLeft: "auto"}}></i>}
                        </div>
        
                        <p className="fz-lg fw-medium mb-md">{option.amount}€ / mois</p>
                        <div style={{flex: 1}}>
                            <p className="text fz-lg m-y-sm">Avantages:</p>
                            <ul>
                                {
                                    option.avantages.map((el, i) => <li key={i}>-  {el}</li>)
                                }
                            </ul>
                        </div>
                    
                    
                        <div style={{display: 'block', marginTop: 'auto', marginBottom: '20p'}}>
                        <div className="wrapper-cta-inline m-y-lg">
                            <button className={isSelected(option.name) ? "cta-bleu cta-small" : "cta-blanc cta-small"} style={{border: "1px solid #144196"}} onClick={(e) => onSelectAction(e, option)}>{isSelected(option.name) ? 'Offre sélectionné': 'Sélectionner'}</button>
                        </div>
                        {
                            isSelected(option.name) && 
                            <div className="wrapper-cta-inline mt-lg">
                            <a className="cta-blanc cta-small" href="#" onClick={(e) => onUnselectAction(e, option)}>Annuler</a>
                        </div>
                        }
                       
                      </div>
                    </div>
                </div>
            ))
        }
      </div>
  


      {
        !showModal && <StickButtonsBloc disabledPreviousButton={proposition && isPropositionInLock(proposition) ? true : false} showNextButton={true} showPreviousButton={true} previousAction={onPreviousAction} nextAction={handleSubmit(onNextAction)}/>
      }
        
      {isSubmitting&&<LoaderModal hasMessage={false}/>}
       
    </form>
  )
}
